import { useEffect, useState } from 'react';

/**
 * The current time, re-read every `intervalMs` (spec 126). For a component
 * that shows an age — only it re-renders on the tick, not the page around it.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(Date.now());
    }, intervalMs);
    return () => {
      window.clearInterval(timer);
    };
  }, [intervalMs]);
  return now;
}
